<div class="mb-5 w-fit rounded-2xl border border-gray-300 bg-gradient-to-r from-gray-50 to-white px-5 py-3">
  <div class="border-l-4 border-gray-800 pl-4">
    <p class="text-xs font-semibold uppercase tracking-[0.18em] text-gray-500">
      Manage Account Section
    </p>
    <h2 class="mt-1 text-2xl font-bold tracking-tight text-gray-900">
      Company Users
    </h2>
  </div>
</div>

<app-index-company></app-index-company>

<ng-template #loading>
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-white/60 backdrop-blur-sm">
    <div class="flex flex-col items-center gap-4 rounded-2xl border border-gray-300 bg-white px-8 py-6">
      <div class="h-10 w-10 animate-spin rounded-full border-4 border-gray-300 border-t-gray-700"></div>
      <p class="text-sm font-medium text-gray-500">
        Loading users...
      </p>
    </div>
  </div>
</ng-template>

<ng-container *ngIf="hasLoaded == true; else loading">
  <main class="px-4 sm:px-5">
    <!-- NAVIGATION -->
    <section class="mb-5">
      <app-index-nav-grid></app-index-nav-grid>
    </section>

    <!-- TOOLBAR -->
    <section class="mb-5 grid grid-cols-1 gap-4 lg:grid-cols-12 lg:items-center">
      <div class="lg:col-span-6">
        <button
          class="primary-btn h-[50px]"
          (click)="showAddUserModal = true"
        >
          Add New User
        </button>
      </div>

      <div class="lg:col-span-6">
        <div class="grid grid-cols-1 gap-4 sm:grid-cols-12 sm:items-center">
          <div class="sm:col-span-5 sm:col-start-8">
            <div class="flex h-[50px] w-full items-center rounded-xl border border-gray-300 bg-white px-3">
              <!-- SEARCH ICON -->
              <mat-icon class="flex-shrink-0 text-gray-400">search</mat-icon>

              <!-- INPUT -->
              <input
                #searchInput
                type="text"
                placeholder="Search..."
                (keyup.enter)="onSearchSubmit(searchInput.value)"
                (input)="searchValue = searchInput.value"
                [(ngModel)]="searchValue"
                class="min-w-0 flex-1 bg-transparent px-2 text-sm text-gray-700 outline-none placeholder:text-gray-400"
              />

              <!-- CLEAR BUTTON -->
              <button
                type="button"
                (click)="clearSearch(); searchInput.value=''; searchValue=''"
                [class.opacity-0]="!searchValue"
                [class.pointer-events-none]="!searchValue"
                class="flex h-9 w-9 flex-shrink-0 cursor-pointer items-center justify-center rounded-lg text-gray-500 transition hover:bg-gray-100 hover:text-gray-800"
              >
                <mat-icon class="text-lg">close</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- TOP PAGINATOR -->
    <section class="mb-4 grid grid-cols-1 gap-4 lg:grid-cols-12 lg:items-center">
      <div class="hidden lg:col-span-6 lg:block"></div>

      <div class="lg:col-span-6 justify-end lg:flex">
        <div class="w-fit overflow-hidden rounded-2xl border border-gray-300 bg-white">
          <mat-paginator
            [length]="totalItems"
            [pageSize]="pageSize"
            [pageSizeOptions]="[pageSize]"
            showFirstLastButtons
            (page)="onPageChange($event)"
          >
          </mat-paginator>
        </div>
      </div>
    </section>

    <!-- USERS TABLE -->
    <section class="grid grid-cols-1 gap-4">
      <div class="col-span-1 overflow-hidden rounded-2xl border border-gray-300 bg-white">
        <div class="w-full overflow-x-auto">
          <mat-table
            [dataSource]="dataSource"
            matSort
            (matSortChange)="onSortChange($event)"
            class="!inline-table !w-full min-w-[980px] table-fixed table-alternate text-sm"
          >
            <!-- ID COLUMN -->
            <ng-container matColumnDef="id">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="w-[100px] whitespace-nowrap bg-gray-50 px-5 py-4 text-left text-xs font-semibold uppercase tracking-[0.14em] text-gray-500"
              >
                ID
              </th>

              <td
                mat-cell
                *matCellDef="let user"
                class="w-[100px] whitespace-nowrap px-5 py-5 text-sm font-medium text-gray-800"
              >
                #{{ user.ID || '' }}
              </td>
            </ng-container>

            <!-- NAME COLUMN -->
            <ng-container matColumnDef="name">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="w-[220px] whitespace-nowrap bg-gray-50 px-5 py-4 text-left text-xs font-semibold uppercase tracking-[0.14em] text-gray-500"
              >
                Name
              </th>

              <td
                mat-cell
                *matCellDef="let user"
                class="w-[220px] px-5 py-5"
              >
                <div class="max-w-[190px] overflow-hidden">
                  <p class="truncate text-sm font-semibold leading-6 text-gray-900">
                    {{ user.FirstName || '' | titlecase }} {{ user.LastName || '' | titlecase }}
                  </p>
                </div>
              </td>
            </ng-container>

            <!-- EMAIL COLUMN -->
            <ng-container matColumnDef="email">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="whitespace-nowrap bg-gray-50 px-5 py-4 text-left text-xs font-semibold uppercase tracking-[0.14em] text-gray-500"
              >
                Email
              </th>

              <td
                mat-cell
                *matCellDef="let user"
                class="px-5 py-5"
              >
                <div class="max-w-[280px] overflow-hidden">
                  <p class="truncate text-sm leading-6 text-gray-700">
                    {{ user.Email || '' | lowercase }}
                  </p>
                </div>
              </td>
            </ng-container>

            <!-- ROLE COLUMN -->
            <ng-container matColumnDef="role">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="w-[170px] whitespace-nowrap bg-gray-50 px-5 py-4 text-left text-xs font-semibold uppercase tracking-[0.14em] text-gray-500"
              >
                Role
              </th>

              <td
                mat-cell
                *matCellDef="let user"
                class="w-[170px] whitespace-nowrap px-5 py-5"
              >
                <span
                  class="inline-flex w-[120px] items-center justify-center rounded-full px-3 py-2 text-xs font-semibold"
                  [ngClass]="{
                    'bg-blue-100 text-blue-800': user.user_group.Name === 'Admin',
                    'bg-green-100 text-green-800': user.user_group.Name === 'ContentUser',
                    'bg-purple-100 text-purple-800': user.user_group.Name === 'Billing',
                    'bg-gray-200 text-gray-800': !user.user_group.Name || user.user_group.Name === 'N/A'
                  }"
                >
                  {{ user.user_group.Name || 'N/A' }}
                </span>
              </td>
            </ng-container>

            <!-- STATUS COLUMN -->
            <ng-container matColumnDef="status">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="w-[150px] whitespace-nowrap bg-gray-50 px-5 py-4 text-left text-xs font-semibold uppercase tracking-[0.14em] text-gray-500"
              >
                Status
              </th>

              <td
                mat-cell
                *matCellDef="let user"
                class="w-[150px] whitespace-nowrap px-5 py-5"
              >
                <span
                  class="inline-flex w-[100px] items-center justify-center rounded-full px-3 py-2 text-xs font-semibold"
                  [ngClass]="{
                    'bg-green-100 text-green-800': user.isActive === 1,
                    'bg-red-100 text-red-800': user.isActive === 0
                  }"
                >
                  {{ user.isActive ? 'Active' : 'Inactive' }}
                </span>
              </td>
            </ng-container>

            <!-- CREATED AT COLUMN -->
            <ng-container matColumnDef="created_at">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="w-[190px] whitespace-nowrap bg-gray-50 px-5 py-4 text-left text-xs font-semibold uppercase tracking-[0.14em] text-gray-500"
              >
                Created At
              </th>

              <td
                mat-cell
                *matCellDef="let user"
                class="w-[190px] whitespace-nowrap px-5 py-5 text-sm text-gray-700"
              >
                {{ (user.created_at | date:'dd/MM/yyyy HH:mm') || '' }}
              </td>
            </ng-container>

            <!-- ACTIONS COLUMN -->
            <ng-container matColumnDef="actions">
              <th
                mat-header-cell
                *matHeaderCellDef
                class="w-[160px] whitespace-nowrap bg-gray-50 px-5 py-4 text-center text-xs font-semibold uppercase tracking-[0.14em] text-gray-500"
              >
                Actions
              </th>

              <td
                mat-cell
                *matCellDef="let user"
                class="w-[160px] whitespace-nowrap px-5 py-5"
              >
                <div class="flex w-full items-center justify-center gap-1">
                  <button
                    mat-icon-button
                    class="cursor-pointer text-gray-600 transition-colors hover:text-blue-600"
                    (click)="editUser(user)"
                  >
                    <mat-icon>edit</mat-icon>
                  </button>

                  <button
                    mat-icon-button
                    class="cursor-pointer text-gray-600 transition-colors hover:text-red-600"
                    (click)="deleteUser(user)"
                  >
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </td>
            </ng-container>

            <!-- TABLE HEADER -->
            <tr
              mat-header-row
              *matHeaderRowDef="displayedColumns"
              class="border-b border-gray-300 bg-gray-50"
            >
            </tr>

            <!-- TABLE ROWS -->
            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumns"
              class="border-b border-gray-100 bg-white transition-colors even:bg-gray-50/40 hover:bg-gray-100"
            >
            </tr>
          </mat-table>
        </div>
      </div>

      <!-- NO DATA MESSAGE -->
      <div
        *ngIf="dataSource.data.length === 0"
        class="col-span-1 rounded-2xl border border-red-200 bg-red-50 px-5 py-4 text-sm font-medium text-red-600"
      >
        No Users found.
      </div>

      <!-- BOTTOM PAGINATOR -->
      <div class="col-span-1 overflow-hidden rounded-2xl border border-gray-300 bg-white">
        <mat-paginator
          [length]="totalItems"
          [pageSize]="pageSize"
          [pageSizeOptions]="[pageSize]"
          showFirstLastButtons
          (page)="onPageChange($event)"
        >
        </mat-paginator>
      </div>
    </section>
  </main>

  <app-footer-grid></app-footer-grid>
</ng-container>

<!-- ADD USER MODAL -->
<div
  *ngIf="showAddUserModal"
  class="fixed inset-0 z-50 flex items-center justify-center px-4 py-6"
  (click)="showAddUserModal = false"
>
  <div class="absolute inset-0 bg-black/40 backdrop-blur-sm"></div>

  <div
    class="relative z-10 flex max-h-[85vh] w-full max-w-2xl flex-col overflow-hidden rounded-2xl border border-gray-300 bg-white"
    (click)="$event.stopPropagation()"
  >
    <!-- MODAL HEADER -->
    <div class="border-b border-gray-300 bg-gradient-to-r from-gray-50 to-white px-5 py-4">
      <div class="grid grid-cols-12 items-center gap-4">
        <div class="col-span-10">
          <h2 class="mt-1 text-xl font-bold tracking-tight text-gray-900 sm:text-2xl">
            Add New User
          </h2>
        </div>

        <div class="col-span-2 flex justify-end">
          <button
            mat-icon-button
            class="rounded-xl text-gray-500 transition hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-gray-300"
            (click)="showAddUserModal = false"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <!-- MODAL CONTENT -->
    <div class="flex-1 overflow-y-auto bg-white p-4 sm:p-6">
      <app-create-user
        [embeddedMode]="true"
        [hasBorder]="false"
        [companyIdInput]="companyID.toString()"
        (onSubmitClbk)="onUserCreated($event)"
      >
      </app-create-user>
    </div>
  </div>
</div>
